
import { GEO_MAP } from '../const/mapping';

export function renderMap(data: any) {
    return {
        type: GEO_MAP,
        data
    };
}
